<script setup lang="ts">
import { KsDialogPortal } from '@aschehoug/kloss-2'
</script>

<template>
  <KsDialogPortal class="dialog-portal">
    <slot />
  </KsDialogPortal>
</template>
